import Button from 'components/Button'
import ConfirmationModal from 'components/ConfirmationModal'
import UseAsyncFn from 'components/UseAsyncFn'

type Props = {
	onClose: () => void
	onDelete: () => Promise<void>
}

function DeleteRuleModal({ onDelete, onClose }: Props) {
	return (
		<ConfirmationModal
			name="ConfirmDisableModal"
			data-testid="DeleteRuleModal"
			title="Are you sure you want to remove this rule?"
			caption="This rule will be permanently removed and cannot be restored."
			hideModal={onClose}
		>
			<Button kind="secondary" onClick={onClose} mediumDesktop>
				Keep it
			</Button>
			<UseAsyncFn asyncFn={onDelete}>
				{({ loading, callAsyncFn }) => (
					<Button type="button" kind="destructive" onClick={callAsyncFn} loading={loading} mediumDesktop>
						Remove
					</Button>
				)}
			</UseAsyncFn>
		</ConfirmationModal>
	)
}

export default DeleteRuleModal
